import { render, staticRenderFns } from "./BuildingsByReferralChart.vue?vue&type=template&id=fe406eb8&scoped=true&"
import script from "./BuildingsByReferralChart.vue?vue&type=script&lang=js&"
export * from "./BuildingsByReferralChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe406eb8",
  null
  
)

export default component.exports